import React, { useState } from 'react'
import { Duration } from 'luxon'

import { TtIcon } from '@23/react'

import { useAppSelector } from '../../../../../../redux-types'
import { useInterval } from '../../../../../../sharedLegacy/hooks'

import './FocusLiveTimer.scss'

const FocusLiveTimer = () => {
  const liveStartTime = useAppSelector(
    (state) => state.webinar.webinarInfo.broadcasting_start_time
  )
  const [remainingTime, setRemainingTime] = useState(
    liveStartTime ? Date.now() - +liveStartTime * 1000 : 0
  )

  useInterval(() => {
    setRemainingTime(liveStartTime ? Date.now() - +liveStartTime * 1000 : 0)
  }, 1000)

  return (
    <div className="focus-widget focus-live-timer">
      {liveStartTime && <TtIcon library="one/spots" name="webinar-spot-live" />}

      {remainingTime > 0 ? (
        <span>
          {Duration.fromMillis(remainingTime + Number.EPSILON).toFormat(
            'mm:ss'
          )}
        </span>
      ) : (
        <span>{Duration.fromMillis(-remainingTime).toFormat('mm:ss')}</span>
      )}
    </div>
  )
}

export { FocusLiveTimer }
